module.exports = __webpack_public_path__ + "img/2-5.d4768b77.png";